export function getComponentDocumentationUrl(componentName: string) {
  return `[Link to the documentation](https://docs.unity.com/en-us/internal/components#${componentName})`;
}
